import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Header_Home from "../Component/Header_Home";
import Header from "../Component/Header";
import "../../App.css";
import "react-datepicker/dist/react-datepicker.css";
import { TextField, Grid, InputLabel, TableFooter } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import "../PaymentInquiry/paymentInquiry-styles.css";
import {
  searchPaymentAPI,
  inquiryAPI,
} from "./ActivityLogInService/activityLogInService";
import Skeleton from "react-loading-skeleton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { TablePagination } from "@material-ui/core";
import "moment/locale/th";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import { DatePicker } from "material-ui-pickers";
import OverwriteMomentBE from "../../util/OverwriteMomentBE";
import moment from "moment";
import { IconButton, InputAdornment } from "@material-ui/core";
import AlarmIcon from "@material-ui/icons/CalendarToday";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";
import { CustomInputText } from "../Component/CustomInputText";
import { CSVLink } from "react-csv";
import { Select, OutlinedInput, MenuItem } from "@mui/material";
import {
  searchDataActivityLog,
} from "../RequestReport/RequestService/requestService";
import { getParameterAPI } from "../PolicyDetail/PolicyDetailService/policyDetailService";

const ActivityLogIn = () => {
  const theme = createTheme({
    components: {
      MuiTableHead: {
        styleOverrides: {
          root: {
            // backgroundColor: "#FFA500",
          },
        },
      },
    },
  });

  useEffect((date) => {
    // getConvertFormat(date)
  }, []);

  const style = {
    py: 0,
    width: "100%",
    maxWidth: 360,
    borderRadius: 2,
    border: "1px solid",
    borderColor: "divider",
    backgroundColor: "background.paper",
  };

  const [payDate, setPayDate] = useState(null);
  const [policyNo, setPolicyNo] = useState("");
  const [rowPayment, setRowPayment] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [refNo, setRefNo] = useState("");
  const [LoadingContent, setLoadingContent] = useState(false);
  const [spinner, setSpinner] = useState();

  const [insureName, setInsureName] = useState("");
  const [idNo, setIdNo] = useState("");
  const [usageType, setUsageType] = useState("");
  const [requestStartDate, setRequestStartDate] = useState("");
  const [requestEndDate, setRequestEndDate] = useState("");
  const [usageStartDate, setUsageStartDate] = useState("");
  const [usageEndDate, setUsageEndDate] = useState("");
  const [dataTable, setDataTable] = useState([]);
  const [optionUsageType, setOptionUsageType] = useState([]);



  const clear = (date) => {
    setIdNo("")
    setInsureName("")
    setUsageType("")
    setRequestStartDate("")
    setRequestEndDate("")
    setUsageStartDate("")
    setUsageEndDate("")
    // setDataTable([]);
    getDataActivityLog()
  };

  function formatDate(dateString) {
    if (!dateString) {
      return "";
    }
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear(); /*+ 543*/
    return `${day}/${month}/${year}`;
  }

  function formatDate2(dateString) {
    if (!dateString) {
      return "";
    }
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear(); /*+ 543*/
    const hour = String(date.getHours()).padStart(2, "0");
    const minute = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} ${hour}:${minute}`;
  }

  function formatCurrency(amount) {
    return new Intl.NumberFormat("th-TH", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeInsureName = (e) => {
    setInsureName(e.target.value);
  };

  const handleChangeIdNo = (e) => {
    setIdNo(e.target.value);
  };

  const handleUsageDateStart = (date) => {
    setUsageStartDate(date);
  };

  const handleUsageDateEnd = (date) => {
    setUsageEndDate(date);
  };

  const handleRqDateStart = (date) => {
    setRequestStartDate(date);
  };

  const handleRqDateEnd = (date) => {
    setRequestEndDate(date);
  };

  const handleUsageType = (e) => {
    setUsageType(e.target.value);
  };

  useEffect(() => {
    getDataActivityLog()
    getUsageType()
  }, []);

  const getUsageType = async () => {
    const result = await getParameterAPI(27);
    const payload = result.payload || [];
  
    const activeOptions = payload
      .filter((item) => item.flagActive === "Y")
      .sort((a, b) => a.name.localeCompare(b.name)); // <-- เรียงตามตัวอักษร
  
    setOptionUsageType(activeOptions);
    console.log(activeOptions);
  };
  
  
  
  

  const generateCsvData = (data) => {
    let data_csv = [];

    data.forEach((item, index) => {
      const data_row = {
        seq: index + 1,
        requestDate: item.request_date
          ? moment(item.request_date).format("DD/MM/YYYY HH:mm")
          : "-",
          phoneNumber: `=""${item.phone_number}""`,
        usageDate: item.usage_date
          ? moment(item.usage_date).format("DD/MM/YYYY HH:mm")
          : "-",
        idNo: item.id_card_or_passport,
        fullName: item.full_name,
        birthDate: item.birth_date
          ? moment(item.birth_date).format("DD/MM/YYYY")
          : "-",
        usageType: item.usage_type,
      };
    
      data_csv.push(data_row);
    });
    

    return data_csv;
  };

  const data_csv = generateCsvData(dataTable);

  const headers = [
    { label: "Request Date", key: "requestDate" },
    { label: "เบอร์โทร", key: "phoneNumber" },
    { label: "วันที่เข้าใช้งาน", key: "usageDate" },
    { label: "เลขประจำตัวประชาชน หรือ เลขที่หนังสือเดินทาง", key: "idNo" },
    { label: "ชิ่อ-นามสกุล ผู้เอาประกัน", key: "fullName" },
    { label: "วันเดือนปีเกิด", key: "birthDate" },
    { label: "ประเภทการใช้งาน", key: "usageType" },
  ];

  const generateFilename = () => {
    const currentDate = moment().format("YYYYMMDDHHmm");
    return `ACTIVITY_LOG_${currentDate}.csv`;
  };

  const getDataActivityLog = async () => {
    setLoadingContent(true);
    const result = await searchDataActivityLog(
      idNo,
      insureName,
      requestStartDate ? moment(requestStartDate).format("YYYY-MM-DD") : "",
      requestEndDate ? moment(requestEndDate).format("YYYY-MM-DD") : "",
      usageStartDate ? moment(usageStartDate).format("YYYY-MM-DD") : "",
      usageEndDate ? moment(usageEndDate).format("YYYY-MM-DD") : "",
      usageType,
    );
    setTimeout(() => {
      // setPage(0);
      setDataTable(result.payload);
      setLoadingContent(false);
    }, 500);
  };

  const onSearch = () => {
    getDataActivityLog().then();
    setPage(0)
  };

  return (
    <div>
      <Header_Home />
      <Header title="ประวัติการเข้าใช้งาน" />
      {spinner && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </div>
      )}
      <div className="table-page-container footer-space">
        <div className="rounded-border bg-white p-2">
          <br />
          <div id="export" className="margin-l-auto text-align-right">
              <CSVLink
                data={data_csv}
                headers={headers}
                filename={generateFilename()}
                style={{ fontSize: 18 }}
                className="btn-fill-export  p-2 bold"
              >
                Export File
              </CSVLink>
            </div>
          <br />
          <Grid
            container
            spacing={2}
            style={{ paddingInline: "32px", marginBottom: "15px" }}
          >
            {/* แถวที่ 1 */}
            <Grid item xs={12} md={6}>
              <CustomInputText
                id="input-policyNo"
                label="ชื่อ-นามสกุล ผู้เอาประกัน"
                placeholder="ชื่อ-นามสกุล ผอป."
                value={insureName}
                onChange={handleChangeInsureName}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <CustomInputText
                id="input-fullname"
                label="เลขประจำตัวประชาชน / เลขที่หนังสือเดินทาง"
                placeholder="เลขประจำตัวประชาชน / เลขที่หนังสือเดินทาง"
                value={idNo}
                onChange={handleChangeIdNo}
                InputProps={{ style: { borderRadius: "16px", height: "42px" } }}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                วันที่เข้าใช้งาน
              </label>
              <MuiPickersUtilsProvider
                utils={OverwriteMomentBE}
                locale="th"
                moment={moment}
              >
                <DatePicker
                  pickerHeaderFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  placeholder="วันที่เริ่มต้น"
                  defaultValue={""}
                  value={usageStartDate || null}
                  onChange={handleUsageDateStart}
                  fullWidth
                  autoOk={true}
                  InputProps={{
                    style: {
                      borderRadius: "16px",
                      height: "42px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <AlarmIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  style={{ borderRadius: "16px", height: "42px" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                &nbsp;
              </label>
              <MuiPickersUtilsProvider
                utils={OverwriteMomentBE}
                locale="th"
                moment={moment}
              >
                <DatePicker
                  pickerHeaderFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  placeholder="วันที่สิ้นสุด"
                  defaultValue={""}
                  value={usageEndDate || null}
                  onChange={handleUsageDateEnd}
                  fullWidth
                  autoOk={true}
                  InputProps={{
                    style: {
                      borderRadius: "16px",
                      height: "42px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <AlarmIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  style={{ borderRadius: "16px", height: "42px" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            {/* แถวที่ 2 */}
            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                Request Date
              </label>
              <MuiPickersUtilsProvider
                utils={OverwriteMomentBE}
                locale="th"
                moment={moment}
              >
                <DatePicker
                  pickerHeaderFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  placeholder="วันที่เริ่มต้น"
                  defaultValue={""}
                  value={requestStartDate || null}
                  onChange={handleRqDateStart}
                  fullWidth
                  autoOk={true}
                  InputProps={{
                    style: {
                      borderRadius: "16px",
                      height: "42px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <AlarmIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  style={{ borderRadius: "16px", height: "42px" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12} md={3}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                &nbsp;
              </label>
              <MuiPickersUtilsProvider
                utils={OverwriteMomentBE}
                locale="th"
                moment={moment}
              >
                <DatePicker
                  pickerHeaderFormat="DD/MM/YYYY"
                  format="DD/MM/YYYY"
                  placeholder="วันที่สิ้นสุด"
                  defaultValue={""}
                  value={requestEndDate || null}
                  onChange={handleRqDateEnd}
                  fullWidth
                  autoOk={true}
                  InputProps={{
                    style: {
                      borderRadius: "16px",
                      height: "42px",
                    },
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton>
                          <AlarmIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="outlined"
                  style={{ borderRadius: "16px", height: "42px" }}
                />
              </MuiPickersUtilsProvider>
            </Grid>

            <Grid item xs={12} md={6}>
              <label htmlFor="from-date" style={{ fontWeight: "bold" }}>
                ประเภทการใช้งาน
              </label>
              <Select
                input={<OutlinedInput />}
                style={{ borderRadius: "16px", height: "42px" }}
                value={usageType}
                onChange={handleUsageType}
                displayEmpty
                fullWidth
              >
                {optionUsageType?.map((value) => (
                  <MenuItem key={value.pmdId} value={value.name}>
                    {value.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
          <br />
          <div className="App">
            <section className="filter-action-section">
              <button
                style={{ fontSize: 18 }}
                onClick={onSearch}
                className="btn-fill-orange  p-2 bold"
              >
                ค้นหา
              </button>
              <button onClick={clear} className="btn-fill-gray p-2 bold ml-2" style={{ marginLeft:'12px' }}>
                ล้าง
              </button>
            </section>
            <br />

            {LoadingContent ? (
              <div className="p-4">
                <div className="p-2">
                  <Skeleton className="h-70px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                  <Skeleton className="h-30px" />
                </div>
              </div>
            ) : (
              <ThemeProvider theme={theme}>
                <TableContainer style={{ height: "auto" }} component={Paper}>
                  <Table aria-label="collapsible table">
                    <TableHead>
                      <TableRow style={{ backgroundColor: "#e7e7e786" }}>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: 300, minWidth: 8 }}
                        >
                          Request Date
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: 200, minWidth: 8 }}
                        >
                          เบอร์โทร
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: 300, minWidth: 8 }}
                        >
                          วันที่เข้าใช้งาน
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: 200, minWidth: 70 }}
                        >
                          เลขประจำตัวประชาชน หรือ เลขที่หนังสือเดินทาง
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: 200, minWidth: 70 }}
                        >
                          ชิ่อ-นามสกุล ผู้เอาประกัน
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: 200, minWidth: 70 }}
                        >
                          วันเดือนปีเกิด
                        </TableCell>
                        <TableCell
                          className="font-new"
                          align="center"
                          style={{ width: 200, minWidth: 30 }}
                        >
                          ประเภทการใช้งาน
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {dataTable.length > 0 ? (
                        dataTable
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((item, idx) => {
                            const seq = idx + 1 + page * rowsPerPage;
                            return (
                              <TableRow key={item.id || idx}>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: 100, minWidth: 8 }}
                                >
                                  {item.request_date
                                    ? moment(item.request_date).format(
                                        "DD/MM/YYYY HH:mm"
                                      )
                                    : "-"}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: 200, minWidth: 8 }}
                                >
                                  {item.phone_number}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: 300, minWidth: 8 }}
                                >
                                  {item.usage_date
                                    ? moment(item.usage_date).format(
                                        "DD/MM/YYYY HH:mm"
                                      )
                                    : "-"}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: 200, minWidth: 70 }}
                                >
                                  {item.id_card_or_passport}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: 200, minWidth: 70 }}
                                >
                                  {item.full_name}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="center"
                                  style={{ width: 200, minWidth: 70 }}
                                >
                                  {item.birth_date
                                    ? moment(item.birth_date).format(
                                        "DD/MM/YYYY"
                                      )
                                    : "-"}
                                </TableCell>
                                <TableCell
                                  className="font-new"
                                  align="left"
                                  style={{ width: 200, minWidth: 30 }}
                                >
                                  {item.usage_type}
                                </TableCell>
                              </TableRow>
                            );
                          })
                      ) : (
                        <TableRow>
                          <TableCell align="center" colSpan={10}>
                            <span className="font-new">ไม่พบข้อมูล</span>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={dataTable.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </TableContainer>
              </ThemeProvider>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityLogIn;
